// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3BCzV","name":"Card_name__1qjZb","img":"Card_img__qr-qd"};